import loadable from '@loadable/component';

export const CreditViewContainerLoadable = loadable(
  () => import('./CreditViewContainer'),
  {
    resolveComponent: (module) => module.CreditViewContainer,
    ssr: false,
  },
);
